import { render, staticRenderFns } from "./FixedPriceAbout.vue?vue&type=template&id=3c33b9aa&"
import script from "./FixedPriceAbout.vue?vue&type=script&lang=js&"
export * from "./FixedPriceAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports